<template>
  <div class="hello page-roster">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div style="min-width: 30px">姓名</div>
            <el-input
              size="small"
              v-model="listQuery.username"
              @keyup.enter.native="getImprtInfo()"
            ></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">身份证号</div>
            <el-input
              size="small"
              v-model="listQuery.idcard"
              @keyup.enter.native="getImprtInfo()"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
        <button
          v-if="checkPermission(['customerList_export'], permissionLists)"
          class="exportButton" style="margin-left: 10px"
          @click="exportInfo"
        >
          导出
        </button>
      </div>

      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>业务立项部门</div>
            <el-select
              v-model="listQuery.strobjinstname"
              placeholder="请输入或选择"
              filterable
            >
              <el-option
                v-for="(item, index) in apartmentList"
                :key="index"
                :label="item.StrObjInstName"
                :value="item.StrObjInstName"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>负责客服</div>
            <el-input size="small" v-model="listQuery.strusername"></el-input>
          </div>
          <div class="formScreenInput">
            <div>合同（协议）类型</div>
            <el-select
              v-model="listQuery.strcontracttype"
              slot="prepend"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="(item, index) in ContractType"
                :value="item"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>户粮</div>
            <el-select
              v-model="listQuery.strcityzentype"
              slot="prepend"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="(item, index) in CityzenType"
                :value="item"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>籍贯</div>
            <el-input size="small" v-model="listQuery.strnativeplace"></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="clear()">
            清空
          </button>
          <button class="search" @click="getImprtInfo()">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <div class="crumbs_left">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>雇员</el-breadcrumb-item>
            <el-breadcrumb-item>雇员管理</el-breadcrumb-item>
            <el-breadcrumb-item>面试入职流程</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/empRosterList?active=花名册列表' }"
              >花名册列表</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{ this.custname }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- <el-tooltip content="撤销删除" placement="left" effect="light">
          <div class="restedelemp">
            <i class="el-icon-refresh-left" @click="restedelemp()"></i>
          </div>
        </el-tooltip> -->
      </div>
      <div class="customerRosterTable">
        <el-table
          :data="tableData"
          :max-height="tableHeight - 180"
          v-loading="listLoading"
          border
          style="width: 99%"
          :cell-style="columnStyle"
          @cell-dblclick="showEditInput"
          :lazy="true"
        >
          <el-table-column align="center" fixed label="排序" width="50">
            <template slot-scope="{ $index }">
              <span>{{
                (Number(listQuery.currpage) - 1) * Number(listQuery.pagecount) + Number($index) + 1
              }}</span>
            </template>
          </el-table-column>
          <template v-for="(item, index) in tableTitle">
            <el-table-column
              :prop="item.StrColumId"
              :label="item.StrColumName"
              fit
              show-overflow-tooltip
              :key="index"
              :width="
                item.StrColumName == '户籍地址' ||
                item.StrColumName == '现住地址' ||
                item.StrColumName == '参保日期' ||
                item.StrColumName == '签订合同起止时间记录' ||
                item.StrColumName == '备注'
                  ? 380
                  : item.StrColumName == '发薪公司全称'
                  ? 280
                  : 180
              "
              align="center"
              :fixed="
                item.StrColumName == '序号' ||
                item.StrColumName == '姓名' ||
                item.StrColumName == '身份证号码'
              "
              v-if="item.StrColumName != '序号'"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    item.StrColumName == '档案号'
                  "
                >
                  <div
                    v-if="scope.row.repeatJudge == 'true'"
                    title="该列不可编辑，该雇员同家公司重复入职"
                  >
                    {{ scope.row[item.StrColumId] }}
                  </div>
                  <div v-else title="该列不可编辑">
                    {{ scope.row[item.StrColumId] }}
                  </div>
                </div>
                <div
                  v-else-if="
                    item.StrColumName == '出生年月' ||
                    item.StrColumName == '判定' ||
                    item.StrColumName == '性别' ||
                    item.StrColumName == '年龄'||
                    item.StrColumName == '姓名'||
                    item.StrColumName == '项目名称' ||
                    item.StrColumName == '项目类别' ||
                    item.StrColumName == '业务立项部门' ||
                    item.StrColumName == '身份证号码'
                  "
                  title="该列不可编辑"
                >
                  {{ scope.row[item.StrColumId] }}
                </div>
                <div
                  title="双击单元格可编辑"
                  v-else-if="
                    item.StrColumName == '身份证有效终止时间' ||
                    item.StrColumName == '用工之日' ||
                    item.StrColumName == '试用期到期日期' ||
                    item.StrColumName == '劳动合同起始时间' ||
                    item.StrColumName == '劳动合同到期时间' ||
                    item.StrColumName == '离职日期' ||
                    item.StrColumName == '实际离职日期' ||
                    item.StrColumName == '工伤发生时间' ||
                    item.StrColumName == '自定义项目5'
                  "
                >
                  {{
                    isNull(scope.row[item.StrColumId])
                      ? ""
                      : scope.row[item.StrColumId]
                  }}
                </div>
                <div
                  title="该列不可编辑"
                  v-else-if="
                    item.StrColumName != '备注' &&
                    item.StrColumName.indexOf('备注') > -1
                  "
                >
                  {{ scope.row[item.StrColumId] }}
                </div>
                <div title="双击单元格可编辑" v-else>
                  {{ scope.row[item.StrColumId] }}
                </div>
              </template>
            </el-table-column>
          </template>
          <el-table-column align="center" fixed="right" label="操作" width="60" v-if="loginUserid == 'caa39434-539c-40cb-95d6-31b215f0f9dc'">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <img
                    src="../../assets/employee/images/more.png"
                    style="width: 14px; height: 16px; cursor: pointer"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item
                    v-if="
                      checkPermission(
                        ['customerRoster_addRemark'],
                        permissionLists
                      )
                    "
                    @click.native="addRemarks(scope.row)"
                  >
                    <img
                      src="../../assets/employee/images/remark.png"
                      class="editEmployee"
                    />添加备注信息
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.StrBlacklist == '是' &&
                      checkPermission(
                        ['customerRoster_addBlacklist'],
                        permissionLists
                      )
                    "
                    @click.native="Yblacklist(scope.row)"
                  >
                    <img
                      src="../../assets/employee/images/blacklist.png"
                      class="editEmployee"
                    />移出黑名单
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.StrBlacklist != '是' &&
                      checkPermission(
                        ['customerRoster_addBlacklist'],
                        permissionLists
                      )
                    "
                    @click.native="blacklist(scope.row)"
                  >
                    <img
                      src="../../assets/employee/images/blacklist.png"
                      class="editEmployee"
                    />添加到黑名单
                  </el-dropdown-item> -->
                  <!-- checkPermission(['customerRoster_dltMember'],permissionLists) -->
                  <el-dropdown-item
                    @click.native="deleteEmployee(scope.row)"
                  >
                    <img
                      src="../../assets/employee/images/del.png"
                      class="editEmployee"
                    />删除雇员信息
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="Number(totalcount) > 0">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="listQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.pagecount"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 备注 -->
      <el-dialog :visible.sync="dialogVisible1" width="30%">
        <div class="diaTitle">添加备注</div>
        <el-input type="textarea" :rows="5" v-model="remarkText"></el-input>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible1 = false">取消</button>
          <button
            class="search"
            @click="confirmRemark()"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
      <!-- 拉黑 -->
      <el-dialog :visible.sync="dialogVisible2" width="30%">
        <div class="diaTitle">确认是否加入黑名单</div>
        <el-input
          type="textarea"
          placeholder="请输入黑名单原因"
          :rows="5"
          maxlength="100"
          show-word-limit
          v-model="blacklistReason"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible2 = false">取消</button>
          <button
            class="search"
            @click="confirmBlack()"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible10" width="30%">
        <div class="delTitle">确认移出黑名单</div>
        <div style="padding: 20px 20px 20px 0">
          请核对雇员信息：姓名{{
            "“" + this.emprow.StrEmpName + "”"
          }}、身份证号码{{ "“" + this.emprow.StrIdCard + "”" }}
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible10 = false">取消</button>
          <button
            class="search"
            @click="confirmYBlack()"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible11" width="70%">
        <div class="errorColumn">
          <div
            class="errorColumnItem"
            v-for="(item, index) in this.errorColumn"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog :visible.sync="dialogVisible3" width="30%">
        <div class="delTitle">确认删除雇员</div>
        <div style="padding: 20px 20px 20px 0">
          请核对雇员信息：姓名{{
            "“" + this.emprow.StrEmpName + "”"
          }}、身份证号码{{ "“" + this.emprow.StrIdCard + "”" }}
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button
            class="search"
            @click="confirmDel()"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>

      <div class="tagArea">
        <!-- 导出 -->
        <el-dialog :visible.sync="dialogVisible4" width="800px">
          <div class="diaTitle">导出</div>
          <div>
            <div style="margin-bottom: 12px; margin-top: 15px; font-size: 16px">
              选择导出字段
            </div>
            <el-tabs type="border-card">
              <el-tab-pane label="导出字段">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                  >全选</el-checkbox
                >
                <div style="margin: 15px 0"></div>
                <el-checkbox-group
                  v-model="checkedFields"
                  @change="handleCheckedCitiesChange"
                >
                  <div class="fieldBox">
                    <el-checkbox
                      v-for="(field, index) in fields"
                      :label="field"
                      :key="index"
                      >{{ field }}</el-checkbox
                    >
                  </div>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
            <div
              class="historyFiled"
              v-show="historyFiled != [] && historyFiled.length > 0"
            >
              <p styele="margin-top:10px;">历史导出字段：</p>
              <el-radio-group
                v-model="radioVal"
                size="medium"
                v-for="(item, index) in historyFiled"
                :key="index + 'a'"
                @change="historyHandle"
              >
                <el-radio
                  :label="item.Key"
                  border
                  style="margin-bottom: 10px"
                  >{{ item.dtOputDate }}</el-radio
                >
              </el-radio-group>
            </div>
            <div style="margin-top: 20px">
              <div class="delTitle">选择导出人员在/离职状态</div>
              <div>
                <div class="dataSele">
                  <el-select
                    v-model="workState"
                    slot="prepend"
                    placeholder="请选择"
                    filterable
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option value="在职"></el-option>
                    <el-option value="离职"></el-option>
                    <el-option value="离职转正"></el-option>
                    <el-option value="自离"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <button class="clear" @click="dialogVisible4 = false">取消</button>
            <button
              class="search"
              @click="confirmExport()"
              style="margin-left: 10px; font-weight: 600"
            >
              确定
            </button>
          </span>
        </el-dialog>
      </div>
      <!-- 导入成功 -->
      <el-dialog :visible.sync="dialogVisible6" width="480px">
        <div class="successBox">
          <div class="successImg">
            <img src="../../assets/employee/images/success.png" />
          </div>
          <div class="successText">导入成功</div>
          <div class="importNum">本次共导入{{ this.totalmain }}条雇员信息</div>
          <div class="importNum2" @click="dialogVisible11 = true">
            本次导入共有{{
              this.errorColumn.length
            }}条格式错误数据，查看格式错误数据的行列
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible6 = false">完成</button>
          <button
            class="search"
            @click="dialogVisible6 = false"
            style="margin-left: 10px; font-weight: 600"
          >
            查看导入数据
          </button>
        </span>
      </el-dialog>
      <!-- 导入失败 -->
      <el-dialog :visible.sync="dialogVisible7" width="480px">
        <div class="successBox">
          <div class="successImg">
            <img src="../../assets/employee/images/failed.png" />
          </div>
          <div class="successText">导入失败</div>
          <div class="importNum">中断原因：网络异常</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible7 = false">关闭</button>
          <button
            class="search"
            @click="dialogVisible7 = false"
            style="margin-left: 10px; font-weight: 600"
          >
            重新导入
          </button>
        </span>
      </el-dialog>

      <!-- 撤销导入 -->
      <el-dialog :visible.sync="dialogVisible8" width="480px">
        <div class="delTitle">撤销导入</div>
        <div style="padding: 20px 20px 20px 0">
          您正在进行撤销导入操作，撤销后结果不可逆，请谨慎操作！
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible8 = false">取消</button>
          <button
            class="search"
            @click="UndoImport"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>

      <!-- 修改劳动合同 -->
      <el-dialog :visible.sync="dialogVisibleContract" width="480px">
        <div class="delTitle">修改劳动合同</div>
        <div class="updateContract">
          <div class="upLeft">
            <div>劳动合同起始时间</div>
            <div class="dataSele">
              <el-date-picker
                v-model="startTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </div>
          <div class="upLeft">
            <div>劳动合同到期时间</div>
            <div class="dataSele">
              <el-date-picker
                v-model="endTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisibleContract = false">
            取消
          </button>
          <button
            class="search"
            @click="editContract"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>

      <!-- 修改单元格信息 -->
      <el-dialog :visible.sync="dialogVisibleEdit" width="480px">
        <div class="delTitle">修改{{ editTxt }}</div>
        <div>
          <div class="upLeft" v-if="editType == 'date'">
            <div class="nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele" v-if="property">
              <el-date-picker
                v-model="tData"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </div>
          <div
            class="screenInput"
            v-else-if="editType == 'input' && property"
            style="margin-top: 20px"
          >
            <div class="nowrap">{{ editTxt + "：" }}</div>
            <el-input size="small" v-model="tData"></el-input>
          </div>
          <div
            v-else-if="
              editType == 'nativeAddr' ||
              editType == 'addr' ||
              (editType == 'insuranceDate' && property)
            "
          >
            <el-input type="textarea" :rows="5" v-model="tData"></el-input>
          </div>
          <div class="selectCell" v-else-if="editType == 'srv' && property">
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="rowInfo.StrSrvCent"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in SrvCent"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="selectCell" v-else-if="editType == 'objname' && property">
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="rowInfo.StrObjName"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in objList"
                  :key="index"
                  :label="item.StrObjName"
                  :value="item.StrObjName"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="selectCell" v-else-if="editType == 'peoject' && property">
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="rowInfo.StrProjectType"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="外包"></el-option>
                <el-option value="代理"></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'username' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="rowInfo.StrUserName"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in subordinateList"
                  :key="index"
                  :label="item.Username"
                  :value="item.Username"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'political' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="群众"></el-option>
                <el-option value="党员"></el-option>
                <el-option value="团员"></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'cityzenType' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in CityzenType"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'nationClass' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in nationals"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="selectCell" v-else-if="editType == 'eduLv' && property">
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in eduLv"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'insuranceType' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in InsuranceType"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'contractType' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in ContractType"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'workState' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option label="全部" value=""></el-option>
                <el-option value="在职"></el-option>
                <el-option value="离职"></el-option>
                <el-option value="离职转正"></el-option>
                <el-option value="自离"></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'bankName' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in bank"
                  :value="item"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'withdrawal' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </div>
          </div>
          <div class="selectCell" v-else-if="editType == 'petype' && property">
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="常规体检"></el-option>
                <el-option value="职业病体检"></el-option>
                <el-option value="无要求"></el-option>
              </el-select>
            </div>
          </div>
          <div class="selectCell" v-else-if="editType == 'peres' && property">
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="正常"></el-option>
                <el-option value="异常"></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'empUsrStatus' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="调岗"></el-option>
                <el-option value="再次入职"></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'disabilityLevel' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="一级"></el-option>
                <el-option value="二级"></el-option>
                <el-option value="三级"></el-option>
                <el-option value="四级"></el-option>
                <el-option value="五级"></el-option>
                <el-option value="六级"></el-option>
                <el-option value="七级"></el-option>
                <el-option value="八级"></el-option>
                <el-option value="九级"></el-option>
                <el-option value="十级"></el-option>
                <el-option value="无等级"></el-option>
                <el-option value="工亡"></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="selectCell"
            v-else-if="editType == 'blacklist' && property"
          >
            <div class="lineTitle nowrap">{{ editTxt + "：" }}</div>
            <div class="dataSele">
              <el-select
                v-model="tData"
                slot="prepend"
                placeholder="请选择"
                filterable
              >
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisibleEdit = false">取消</button>
          <button
            class="search"
            @click="editCellInfo"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FUN from "../../fun";
import xz from "../../common";
import checkPermission from "@/utils/permission"; // 权限判断函数
export default {
  name: "customerRoster",
  data() {
    return {
      canvasImg: "./../../../assets/images/qrcode.png",
      workState: "在职",
      tablePath: this.$store.state.EMP.tablePath,
      //修改标题
      editTxt: "",
      //修改弹窗
      dialogVisibleEdit: false,
      //修改时的临时数据
      tData: "",
      //修改时整行数据
      rowInfo: null,
      //字段名字
      property: "",
      //修改类型
      editType: "",
      // 表头参数
      titleQuery: {
        strTableId: 'JB_emp_UserBase',
        strIsFixed: '' // 1 基础 0 扩展 空 所有
      },
      style1: {
        color: "rgb(255, 67, 98)",
      },
      tableHeight: 0,
      apartmentList: [],
      pagecount: 10,
      //历史导入字段
      historyChecked: "",
      //单选框
      radioVal: "",
      historyFiledList: [],
      listLoading: false,
      //是否覆盖
      isReset: false,
      //导入步骤
      active: 0,
      //文件是否已上传
      isFileSuccess: false,
      historyFiled: "",
      dialogVisible11: false,
      errorColumn: [],
      strsrvcentSel: "",
      //下拉项目名称
      objList: [],
      //下级人员列表(负责客服)
      subordinateList: [],
      dialogVisible10: false,
      blackstatus: "",
      tableclumn: [],
      oldCluvalue: "",
      remarkText: "",
      blacklistReason: "",
      //表头内容
      tableTitle: [],
      lsdata: "",
      path: "",
      qdata: [],
      empinfo: "",
      instname: "",
      servusrname: "",
      servcentname: "",
      custname: "",
      entid: "",
      process: 0,
      infoPath: "",
      totalmain: "",
      inputValue: "",
      bank: this.$store.state.EMP.bank,
      CityzenType: this.$store.state.EMP.CityzenType,
      //分公司
      SrvCent: this.$store.state.EMP.SrvCent,
      //合同类型
      ContractType: this.$store.state.EMP.ContractType,
      InsuranceType: this.$store.state.EMP.InsuranceType,
      //学历水平
      eduLv: this.$store.state.EMP.eduLv,
      //民族
      nationals: this.$store.state.EMP.nationals,
      checkAll: false,
      //字段选择默认选择
      checkedFields: [],
      fields: [],
      isIndeterminate: true,
      //手机号码格式是否正确
      phoneJudge: "",
      contTelJudge: "",
      totalcount: 0,
      // 列表参数
      listQuery:{
        custname: '',
        tableid: "JB_emp_UserBase",
        pagecount: 10,
        currpage: 1,
        username: '',
        idcard: '',
        strcontracttype: '',
        strnativeplace: '',
        strcityzentype: '',
        strusername: '',
        strobjinstname: ''
      },
      //导入成功
      dialogVisible6: false,
      //导入失败
      dialogVisible7: false,
      //撤销导入
      dialogVisible8: false,
      //设置花名册显示字段
      dialogVisible9: false,
      //导出
      dialogVisible4: false,
      //备注
      dialogVisible1: false,
      //拉黑
      dialogVisible2: false,
      //删除
      dialogVisible3: false,
      reimp: 0,
      reimpLab: "0",
      drawer: false,
      //下拉筛选
      showDropScreen: -1,
      textarea: "",
      tableData: [],
      dynamicTags: ["标签一", "标签二", "标签三"],
      emprow: "",
      //所有导入字段
      currFileData: [],
      //修改劳动合同弹窗
      dialogVisibleContract: false,
      startTime: new Date(),
      endTime: new Date(),
      contractRow: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
        ],
      },
      //重复入职员工身份证号码字符串
      repeatidcard: "",
      //导入状态查询参数
      stateInfoQuery: {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "JB_emp_UserBase",
        instname: "",
        datestart: "",
        dateend: "",
        objname: "",
        strobjinstname: "",
        strusername: "",
        impdate: "",
      },
      allFieldList: [],
      codeloading: false,
      // 生成二维码
      codeQuery: {
        Id: "", // 岗位ID
        pagepath: "pages/enter/enter", // 页面URL
        strLinkType: "D", //A-报名二维码，B-到面二维码,C-入职二维码 D-简历采集二维(ID传空)
      },
      loginRoleType: "",
      // 按钮权限参数
      butQuery: {
        path: "/customerList",
        powerEnName: "projectManage",
      },
      permissionLists: [],
      imgPath: this.$store.state.EMP.imgPath,
      // 删除参数
      dltQuery:{
        StrExcelPath:'',
        IntExcelLine:''
      },
      // 是否可导入或删除
      isBtnHandle: "0", // 0不可1可
      loginUserid: Cookies.get('userid-b')
    };
  },
  computed: {},
  created() {
    this.loginRoleType = localStorage.loginRoletype;
    this.calHeight();
    this.getApartmentList();
    this.isHandleList();
    this.getButtonPower();
    //下拉项目名称
    this.getObjList(this.strsrvcentSel);
    //下拉客服
    this.getMemberList();
    //自定义字段
    this.getCustomList();
    //固定字段
    this.getImportFiledList();
    let q = this.$route.query;
    // console.log('q',q)
    this.infoPath = "雇员花名册>" + q.servcentname + ">" + q.custname;
    (this.instname = q.instname),
      (this.servusrname = q.servusrname),
      (this.servcentname = q.servcentname),
      (this.custname = q.custname),
      (this.entid = q.entid);
      this.listQuery.custname = q.custname
    this.getImprtInfo();
  },
  methods: {
    checkPermission,
    // 复制链接
    repeatHandle() {
      // 后台传回的链接 location.origin
      let url = "https://dev.joball.net";
      navigator.clipboard.writeText(url).then(() => {
        this.$message.success("复制成功");
      });
    },
    // 获取按钮权限
    getButtonPower() {
      xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
        // console.log('按钮',res)
        if (res.status == "ok") {
          let resmsg = res.msg;
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
          } else {
            this.permissionLists = [];
          }
        } else {
          this.permissionLists = [];
        }
      });
    },
    //生成二维码
    cerateQCode() {
      this.getCode();
    },
    // 获取二维码
    getCode() {
      this.codeloading = true;
      xz.getapplyjoobqrcodegenerated(this.loginRoleType, this.codeQuery).then(
        (res) => {
          // console.log('eee', res)
          if (res.status == "ok") {
            let result = res.data;
            this.canvasImg = this.imgPath + result;
          }
          this.codeloading = false;
          // console.log('getStateLists', this.data.status)
        }
      );
    },
    //获取表格高度
    calHeight() {
      this.tableHeight = Number(document.documentElement.clientHeight);
      console.log("height", this.tableHeight);
    },
    //下拉项目名称
    getObjList(strsrvcent) {
      xz.getsrarchinstobjlist(strsrvcent).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          if (
            apartmentData.StrObjName != "" &&
            apartmentData.StrObjName != " "
          ) {
            dataList.push({ StrObjName: apartmentData.StrObjName });
          }
        }
        // console.log("getServeList", dataList);
        this.objList = dataList;
      });
    },
    //下级人员列表
    getMemberList() {
      xz.getallEmplowertListInfo().then((res) => {
        // console.log('下级人员列表',res)
        if (res.data && Array.isArray(res.data)) {
          this.subordinateList = res.data;
        } else {
          this.subordinateList = [];
        }
      });
    },
    handleCurrentChange(val) {
      this.listQuery.currpage = Number(val);
      this.getImprtInfo();
    },
    handleSizeChange(val) {
      this.listQuery.pagecount = parseInt(val);
      this.listQuery.currpage = 1;
      this.getImprtInfo();
    },
    clear() {
      this.listQuery = this.$options.data.call(this).listQuery;
    },
    //点击历史导出单选框
    historyHandle(val) {
      // console.log('rfd', JSON.parse(val))
      this.checkedFields = [];
      if (!this.isNulls(val)) {
        this.tableclumn = JSON.parse(val);
        let historyData = JSON.parse(val);
        for (let index = 0; index < historyData.length; index++) {
          const elementHistoryData = historyData[index];
          this.checkedFields.push(elementHistoryData.name);
        }
      } else {
        this.tableclumn = [];
        this.checkedFields = [];
      }
      // console.log('rfd',this.checkedFields,this.tableclumn)
    },
    //获取表头字段
    getCustomList() {
      this.fields = [];
      xz.getJbbasePageColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then((res) => {
        // console.log("获取表头字段", res);
        if (res && res.msg.length > 0) {
          for (let index = 0; index < res.msg.length; index++) {
            const elementRes = res.msg[index];
            this.allFieldList.push({
              name: elementRes.StrColumName,
              colname: elementRes.StrColumId,
              intOrderId: elementRes.IntOrderId,
            });
          }
          try {
            res.msg.forEach((element) => {
              if (element.StrColumName == "身份证号码") {
                let a1 = {
                  StrColumId: "idcardJudge",
                  StrColumName: "判定",
                };
                let a2 = {
                  StrColumId: "sex",
                  StrColumName: "性别",
                };
                let a3 = {
                  StrColumId: "birth",
                  StrColumName: "出生年月",
                };
                let a4 = {
                  StrColumId: "age",
                  StrColumName: "年龄",
                };
                res.msg.splice(element.IntOrderId + 1, 0, a1, a2, a3, a4);
                this.tableTitle = res.msg;
                throw new Error("ending");
              }
            });
          } catch (e) {
            if (e.message != "ending") throw e;
          }
          this.tableTitle = res.msg;
        } else {
          this.tableTitle = [];
        }
      });
    },
    //获取所有字段信息
    getImportFiledList() {
      this.fields = [];
      xz.getJbbasePageColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then((res) => {
        // console.log('固定导出字段',res)
        if (res && res.msg.length > 0) {
          for (let index = 0; index < res.msg.length; index++) {
            const elementRes = res.msg[index];
            this.fields.push({
              name: elementRes.StrColumName,
              colname: elementRes.StrColumId,
              intOrderId: elementRes.IntOrderId,
            });
          }
          //去重
          this.currFileData = this.unique(this.fields);
          // console.log('ss',this.currFileData)
          this.fields = [];
          for (let index = 0; index < this.currFileData.length; index++) {
            const elementData = this.currFileData[index];
            this.fields.push(elementData.name);
          }
          // console.log('ss',this.fields)
        }
      });
    },
    //判断是否为空(包含0)
    isNulls(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0
      );
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      );
    },
    //双击单元格编辑雇员信息
    showEditInput(row, column, cell, event) {
      if (column.label == "排序") {
        return false;
      }
      if (column.label.indexOf("备注") > -1 && column.label != "备注") {
        return false;
      }
      if (
        column.label == "劳动合同起始时间" ||
        column.label == "劳动合同到期时间"
      ) {
        // console.log('fjdksfj', row)
        if (row.DtContractBtime != "1900-01-01") {
          this.startTime = row.DtContractBtime;
        } else {
          let str = new Date();
          this.startTime =
            str.getFullYear() +
            "-" +
            (str.getMonth() + 1 < 10
              ? "0" + (str.getMonth() + 1)
              : str.getMonth() + 1) +
            "-" +
            (str.getDate() < 10 ? "0" + str.getDate() : str.getDate());
        }
        if (row.DtContractTime != "1900-01-01") {
          this.endTime = row.DtContractTime;
        } else {
          let str = new Date();
          this.endTime =
            str.getFullYear() +
            "-" +
            (str.getMonth() + 1 < 10
              ? "0" + (str.getMonth() + 1)
              : str.getMonth() + 1) +
            "-" +
            (str.getDate() < 10 ? "0" + str.getDate() : str.getDate());
        }
        this.contractRow = row;
        this.dialogVisibleContract = true;
      } else if (
        column.label == "身份证有效终止时间" ||
        column.label == "用工之日" ||
        column.label == "试用期到期日期" ||
        column.label == "离职日期" ||
        column.label == "实际离职日期" ||
        column.label == "工伤发生时间" ||
        column.label == "格式纠纷结束时间"
      ) {
        this.rowInfo = row;
        this.tData = row[column.property];
        if (
          row.DtIcCareEdate == "1900-01-01" ||
          row.DtEntryBdate == "1900-01-01" ||
          row.DtProbationEdate == "1900-01-01" ||
          row.DtDepartureDate == "1900-01-01" ||
          row.DtRealDepartureDate == "1900-01-01" ||
          row.DtInjuryBdate == "1900-01-01" ||
          row.DtInjuryEdate == "1900-01-01"
        ) {
          let str = new Date();
          this.tData =
            str.getFullYear() +
            "-" +
            (str.getMonth() + 1 < 10
              ? "0" + (str.getMonth() + 1)
              : str.getMonth() + 1) +
            "-" +
            (str.getDate() < 10 ? "0" + str.getDate() : str.getDate());
        }
        this.editType = "date";
        this.editTxt = column.label;
        this.property = column.property;
        this.dialogVisibleEdit = true;
      } else if (
        column.label == "身份证号码" ||
        column.label == "签订合同起止时间记录" ||
        column.label == "出生年月" ||
        column.label == "判定" ||
        column.label == "性别" ||
        column.label == "姓名" ||
        column.label == "项目名称" ||
        column.label == "项目类别" ||
        column.label == "业务立项部门" ||
        column.label == "年龄"
      ) {
        this.$message.warning("该列不可编辑");
        return
      } else if (column.label == "备注") {
        this.addRemarks(row);
      } else {
        if (column.label == "服务中心") {
          this.editType = "srv";
        } else if (column.label == "项目名称") {
          this.editType = "objname";
        } else if (column.label == "项目类别") {
          this.editType = "peoject";
        } else if (column.label == "负责客服") {
          this.editType = "username";
        } else if (column.label == "政治面貌") {
          this.editType = "political";
        } else if (column.label == "户粮") {
          this.editType = "cityzenType";
        } else if (column.label == "民族") {
          this.editType = "nationClass";
        } else if (column.label == "教育程度") {
          this.editType = "eduLv";
        } else if (column.label == "参保种类") {
          this.editType = "insuranceType";
        } else if (column.label == "合同（协议）类型") {
          this.editType = "contractType";
        } else if (column.label == "在/离职状态") {
          this.editType = "workState";
        } else if (column.label == "银行") {
          this.editType = "bankName";
        } else if (column.label == "是否计提") {
          this.editType = "withdrawal";
        } else if (column.label == "体检类型") {
          this.editType = "petype";
        } else if (column.label == "体检结果") {
          this.editType = "peres";
        } else if (column.label == "人员状态") {
          this.editType = "empUsrStatus";
        } else if (column.label == "伤残等级") {
          this.editType = "disabilityLevel";
        } else if (column.label == "是否黑名单") {
          this.editType = "blacklist";
        } else if (column.label == "户籍地址") {
          this.editType = "nativeAddr";
        } else if (column.label == "现住地址") {
          this.editType = "addr";
        } else if (column.label == "参保日期") {
          this.editType = "insuranceDate";
        } else {
          this.editType = "input";
        }
        this.rowInfo = row;
        this.editTxt = column.label;
        this.property = column.property;
        this.tData = row[column.property];
        this.dialogVisibleEdit = true;
      }
    },
    //修改单元格信息
    editCellInfo() {
      const data = {
        tableid: "JB_emp_UserBase",
        excelpath: this.rowInfo.StrExcelPath,
        execlline: this.rowInfo.IntExcelLine,
        cluname: this.property,
        cluvalue: this.tData,
      };
      xz.bmodifycurrdata(data).then((res) => {
        if (res == true) {
          this.dialogVisibleEdit = false;
          this.getImprtInfo();
          this.$message({
            message: "修改成功！",
            type: "success",
          });
        } else {
          this.dialogVisibleEdit = false;
          this.getImprtInfo();
          this.$message.error("修改失败！");
        }
      });
    },
    //修改劳动合同
    editContract() {
      console.log("hello");
      if (!this.startTime || !this.endTime) {
        this.$message.warning("请选择劳动合同开始时间和结束时间！");
        this.dialogVisibleContract = false;
        return;
      }
      let row = this.contractRow;
      const data = {
        tableid: "JB_emp_UserBase",
        excelpath: row.StrExcelPath,
        execlline: row.IntExcelLine,
        cluname: "DtContractBtime",
        cluvalue: this.startTime,
      };
      const data2 = {
        tableid: "JB_emp_UserBase",
        excelpath: row.StrExcelPath,
        execlline: row.IntExcelLine,
        cluname: "DtContractTime",
        cluvalue: this.endTime,
      };
      xz.bmodifycurrdata(data).then((res) => {
        if (res == true) {
          xz.bmodifycurrdata(data2).then((res2) => {
            if (res2) {
              this.dialogVisibleContract = false;
              this.getImprtInfo();
              this.$message({
                message: "劳动合同修改成功！",
                type: "success",
              });
            }
          });
        } else {
          this.dialogVisibleContract = false;
          this.$message.error("劳动合同修改失败！请重新修改！");
          this.getImprtInfo();
        }
      });
    },
    //修改手机号
    editPhone(row, column) {
      var cluvalue = document.getElementById(
        row.IntExcelLine + column.id
      ).value;
      if (this.oldCluvalue == cluvalue) {
        this.$delete(row, "isEdit");
        this.$delete(row, "EditName");
        return;
      }
      this.$confirm("请确认是否修改", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const regMobile =
            /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
          if (regMobile.test(cluvalue)) {
            const data = {
              tableid: "JB_emp_UserBase",
              excelpath: row.StrExcelPath,
              execlline: row.IntExcelLine,
              cluname: column.property,
              cluvalue: cluvalue,
            };
            xz.bmodifycurrdata(data).then((res) => {
              if (res == true) {
                row = this.qdata;
                this.$message({
                  message: "雇员信息修改成功！",
                  type: "success",
                });
              } else {
                this.$message.error("雇员信息修改失败！");
                this.getImprtInfo();
              }
            });
            this.$delete(row, "isEdit");
            this.$delete(row, "EditName");
          } else {
            this.$message.error("手机号码格式错误！请核对手机号码");
            this.getImprtInfo();
          }
        })
        .catch((err) => {
          console.log("err", err);
          this.getImprtInfo();
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
      this.$delete(row, "isEdit");
      this.$delete(row, "EditName");
      console.log(row);
    },
    chooseUser(d) {
      this.lsdata = d.label;
      console.log("q", this.lsdata);
    },
    //备注
    addRemarks(row) {
      this.emprow = row;
      // console.log('row',row)
      this.dialogVisible1 = true;
      this.remarkText = this.emprow.StrRemark;
    },
    //确认备注
    confirmRemark() {
      const data = {
        tableid: "JB_emp_UserBase",
        excelpath: this.emprow.StrExcelPath,
        execlline: this.emprow.IntExcelLine,
        cluname: "StrRemark",
        cluvalue: this.remarkText,
      };
      xz.bmodifycurrdata(data).then((res) => {
        if (res == true) {
          this.$message({
            message: "雇员信息修改成功！",
            type: "success",
          });
          this.getImprtInfo();
        } else {
          this.$message.error("雇员信息修改失败！");
          this.getImprtInfo();
        }
      });
      this.dialogVisible1 = false;
    },
    //删除
    deleteEmployee(row) {
      this.emprow = row;
      this.dltQuery = {
        StrExcelPath: row.StrExcelPath,
        IntExcelLine: row.IntExcelLine
      }
      // console.log('row',this.emprow)
      this.dialogVisible3 = true;
    },
    //确认删除
    confirmDel() {
      xz.bdelempuser(this.dltQuery).then((res) => {
        if (res) {
          this.$message({
            message:
              "删除成功，数据量大可能会有延迟，数据没删掉之前请不要导入！",
            type: "success",
          });
          this.getImprtInfo();
          this.dialogVisible3 = false;
          this.emprow = "";
        } else {
          this.$message.error("系统异常，请于管理员联系");
          this.dialogVisible3 = false;
          this.emprow = "";
        }
      });
    },
    //撤销删除
    restedelemp() {
      xz.restedelemp().then((res) => {
        if (res) {
          this.$message({
            message: "撤销删除成功",
            type: "success",
          });
          this.getImprtInfo();
        } else {
          this.$message.error("撤销删除失败！请确认是否有可撤销的信息");
        }
      });
    },
    //拉黑
    blacklist(row) {
      this.emprow = row;
      this.blacklistReason = row.StrBlacklistReason;
      this.dialogVisible2 = true;
    },
    //确认拉黑
    confirmBlack() {
      const data = {
        fileno: this.emprow.StrFileNo,
        blacklistreason: this.blacklistReason,
        blackstatus: "是",
      };
      xz.blacklistEmp(data).then((res) => {
        if (res) {
          this.$message({
            message: "拉黑成功",
            type: "success",
          });
          this.getImprtInfo();
          this.dialogVisible2 = false;
          this.emprow = "";
        } else {
          this.$message.error("系统异常，请于管理员联系");
          this.dialogVisible2 = false;
          this.emprow = "";
        }
      });
    },
    //移出黑名单
    Yblacklist(row) {
      this.emprow = row;
      this.dialogVisible10 = true;
    },
    //确认移出
    confirmYBlack() {
      const data = {
        fileno: this.emprow.StrFileNo,
        blacklistreason: "",
        blackstatus: "否",
      };
      xz.blacklistEmp(data).then((res) => {
        if (res) {
          this.$message({
            message: "移出黑名单成功",
            type: "success",
          });
          this.dialogVisible10 = false;
          this.emprow = "";
          this.getImprtInfo();
        } else {
          this.$message.error("系统异常，请于管理员联系");
          this.dialogVisible10 = false;
          this.emprow = "";
        }
      });
    },
    //导出字段全选
    handleCheckAllChange(val) {
      this.tableclumn = this.currFileData;
      this.checkedFields = val ? this.fields : [];
      if (val == false) {
        this.tableclumn = [
          { colname: "StrIdCard", name: "身份证号码", intOrderId: 13 },
        ];
      }
      this.isIndeterminate = false;
      console.log("d", val, this.checkedFields, this.tableclumn);
    },
    //导出字段选择
    handleCheckedCitiesChange(value) {
      console.log("val", value);
      this.tableclumn = [
        { colname: "StrIdCard", name: "身份证号码", intOrderId: 13 },
      ];
      for (let index = 0; index < this.currFileData.length; index++) {
        // const elementFileDatas = this.currFileData[index];
        if (value != "" && value != null) {
          for (let i = 0; i < value.length; i++) {
            // const elementVal = value[index];
            if (value[i] == this.currFileData[index].name) {
              this.tableclumn.push(this.currFileData[index]);
            }
          }
        } else {
          this.tableclumn = [
            { colname: "StrIdCard", name: "身份证号码", intOrderId: 13 },
          ];
        }
      }
      //去重
      this.tableclumn = this.unique(this.tableclumn);
      // console.log('val', this.tableclumn)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.fields.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.fields.length;
    },
    //去重
    unique(arr) {
      const resList = new Map();
      return arr.filter(
        (arr) => !resList.has(arr.name) && resList.set(arr.name, 1)
      );
    },
    //确认导出
    confirmExport() {
      if (!this.checkAll) {
        this.tableclumn.sort(function (a, b) {
          return a.intOrderId - b.intOrderId;
        });
      }
      // console.log("this.tableclumn", this.tableclumn);
      const data = {
        strworkstate: this.workState,
        custname: this.custname,
        outtype: "0",
        tableid: "JB_emp_UserBase",
        roletype: localStorage.loginRoletype,
        tableclumn: this.tableclumn,
      };
      // console.log('ll', this.tableclumn, data)
      if (this.isNulls(this.tableclumn)) {
        this.$message({
          message: "请选择导出字段",
          type: "warning",
        });
        return false;
      } else {
        var Promise = xz.bdowncurrdata(data);
        this.$router.push({
          path: "/resImportList",
          query: {
            showPage: 1,
            isActive: 1,
            custname: this.custname,
            qStstus: 1,
          },
        });
        this.dialogVisible4 = false;
      }
    },
    //确认导出
    exportInfo() {
      this.dialogVisible4 = true;
      this.radioVal = "";
      this.checkedFields = [];
      xz.bgetimphistorycfg().then((res) => {
        // console.log("dd", res);
        if (res.length && res.length > 0) {
          res.forEach((l) => {
            l.dtOputDate = l.dtOputDate.substring(0, 10);
            if (l.Key != "" && l.Key != null) {
              let historyData = JSON.parse(l.Key);
              // console.log('dd',historyData)
              this.historyFiledList = historyData;
            }
          });
          this.historyFiled = res;
          this.radioVal = res[0].Key;
          if (res[0].Key != "" && res[0].Key != null) {
            for (
              let index = 0;
              index < JSON.parse(res[0].Key).length;
              index++
            ) {
              const elementsData = JSON.parse(res[0].Key)[index];
              this.checkedFields.push(elementsData.name);
            }
            this.tableclumn = JSON.parse(res[0].Key);
          } else {
            this.tableclumn = [];
          }
        } else {
          this.historyFiled = [];
          this.tableclumn = [];
        }
      });
    //   console.log("this.radioVal", this.radioVal);
    },
    // 判断是否可导入或删除
    isHandleList() {
      xz.getSystemConfig().then((res) => {
        // console.log('kk',res)
        if (res.status == "ok") {
          this.isBtnHandle = res.msg;
        }
      });
    },
    //确定撤销导入
    UndoImport() {
      xz.empUndoinputData(this.custname).then((res) => {
        // console.log('撤销导入',res)
        if (res.status == "ok") {
          this.$message({
            message: "撤销导入成功",
            type: "success",
          });
          this.dialogVisible8 = false;
          this.getImprtInfo();
        } else {
          this.$message({
            message: "撤销导入失败",
            type: "warning",
          });
        }
      });
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //设置花名册显示字段
    setFieldShow() {
      this.dialogVisible9 = true;
    },
    removeField(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    //获取表格路径
    getExcelPath() {
      const data = {
        pagecount: 1,
        currpage: 1,
        excelname: "",
        tableid: "",
        instname: "",
        impdate: ""
      };
      xz.getPathInfo(data).then((res) => {
        this.path = res.data[0].StrExcelPath;
        // console.log('pathInfo',this.path)
        this.getImprtInfo();
      });
    },
    //获取花名册信息
    getImprtInfo() {
      // console.log('pathInfo',this.path)
      this.listLoading = true;
      xz.bgetcurrdata(this.listQuery).then((res) => {
        // console.log('xx',res)
        if (res.repeatidcard) {
          this.repeatidcard = res.repeatidcard;
        }
        if (res.data && res.data.length > 0) {
          res.data.forEach((l) => {
            l.DtEntryBdate
              ? (l.DtEntryBdate = l.DtEntryBdate.substring(0, 10))
              : "-";
            l.DtProbationEdate
              ? (l.DtProbationEdate = l.DtProbationEdate.substring(0, 10))
              : "-";
            l.DtContractBtime
              ? (l.DtContractBtime = l.DtContractBtime.substring(0, 10))
              : "-";
            l.DtContractTime
              ? (l.DtContractTime = l.DtContractTime.substring(0, 10))
              : "-";
            l.DtDepartureDate
              ? (l.DtDepartureDate = l.DtDepartureDate.substring(0, 10))
              : "-";
            l.DtRealDepartureDate
              ? (l.DtRealDepartureDate = l.DtRealDepartureDate.substring(0, 10))
              : "-";
            l.DtInjuryBdate
              ? (l.DtInjuryBdate = l.DtInjuryBdate.substring(0, 10))
              : "-";
            l.DtIcCareEdate
              ? (l.DtIcCareEdate = l.DtIcCareEdate.substring(0, 10))
              : "-";
            l.DtInsuranceDate ? (l.DtInsuranceDate = l.DtInsuranceDate) : "-";
            l.DtInjuryEdate
              ? (l.DtInjuryEdate = l.DtInjuryEdate.substring(0, 10))
              : "-";
            if (this.repeatidcard.indexOf(l.StrIdCard) != -1) {
              l["repeatJudge"] = "true";
            } else {
              l["repeatJudge"] = "false";
            }
          });
          this.tableData = res.data;
          this.totalcount = parseInt(res.totalcount);
          this.getPsInfo();
          // this.judgePhone();
        } else {
          this.tableData = [];
        }
        this.listLoading = false;
        //  this.clear();
        this.showDropScreen = -1;
      });
    },
    //获取出生年月、性别、年龄
    getPsInfo() {
      this.tableData.forEach((l) => {
        if (l.StrIdCard.length == 18) {
          let idcode = l.StrIdCard;
          // 加权因子
          var weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          // 校验码
          var check_code = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2",
          ];
          var code = idcode + "";
          var last = idcode[17].toUpperCase(); //最后一个
          var seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          var arr = seventeen.split("");
          var len = arr.length;
          var num = 0;
          for (var i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];

          // 格式的正则
          // 正则思路
          /*
          第一位不可能是0
          第二位到第六位可以是0-9
          第七位到第十位是年份，所以七八位为19或者20
          十一位和十二位是月份，这两位是01-12之间的数值
          十三位和十四位是日期，是从01-31之间的数值
          十五，十六，十七都是数字0-9
          十八位可能是数字0-9，也可能是X
          */
          // var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          var idcardJudge = null;
          if (last === last_no && format == true) {
            idcardJudge = "true";
          } else {
            idcardJudge = "false";
          }

          // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码

          //获取出生年月、性别、年龄
          let myDate = new Date();
          let month = myDate.getMonth() + 1;
          let day = myDate.getDate();
          let iden = idcode;
          let sexnum = null;
          let sex = null;
          let birth = null;
          let age = 0;
          age = myDate.getFullYear() - iden.substring(6, 10) - 1;
          sexnum = iden.substring(16, 17);
          if (sexnum % 2 === 0) {
            sex = "女";
          } else {
            sex = "男";
          }
          birth =
            iden.substring(6, 10) +
            "-" +
            iden.substring(10, 12) +
            "-" +
            iden.substring(12, 14);
          if (
            iden.substring(10, 12) < month ||
            (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
          )
            age++;
          l["birth"] = birth;
          l["sex"] = sex;
          l["age"] = age;
          l["idcardJudge"] = idcardJudge;
        } else {
          let count = this.searchChar(l.StrIdCard);
          let arr = [];
          if (count == 0) {
            l["birth"];
            l["sex"];
            l["age"];
            l["idcardJudge"] = "false";
          } else if (count == 2) {
            l["idcardJudge"] = "true";
            arr = l.StrIdCard.split("-");
            console.log("arr=", arr);
            l["StrIdCard"] = arr[0];
            let sex = arr[2] == "1" ? "男" : "女";
            let birth = arr[1].split("");
            birth.splice(4, 0, "-");
            birth.splice(7, 0, "-");
            birth = birth.join("");
            let myDate = new Date();
            let month = myDate.getMonth() + 1;
            let day = myDate.getDate();
            let age = myDate.getFullYear() - arr[1].substring(0, 4) - 1;
            if (
              arr[1].substring(4, 6) < month ||
              (arr[1].substring(4, 6) == month && arr[1].substring(6, 8) <= day)
            )
              age++;
            l["birth"] = birth;
            l["sex"] = sex;
            l["age"] = age;
          } else {
            l["idcardJudge"] = "false";
          }
        }
      });
    },
    //判断'-'出现几次
    searchChar(str) {
      let count = 0;
      let origialLength = str.length;
      str = str.replace(/\-/g, "");
      let newLength = str.length;
      count = origialLength - newLength;
      return count;
    },
    //判断手机号码格式
    judgePhone() {
      this.tableData.forEach((l) => {
        const regMobile =
          /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
        if (l.StrPhoneNum) {
          if (regMobile.test(l.StrPhoneNum)) {
            this.phoneJudge = "true";
          } else {
            this.phoneJudge = "false";
          }
          l["judgePhone"] = this.phoneJudge;
        }
        if (l.StrContTel) {
          if (regMobile.test(l.StrContTel)) {
            this.contTelJudge = "true";
          } else {
            this.contTelJudge = "false";
          }
          l["contTelJudge"] = this.contTelJudge;
        }
      });
    },
    //格式出错字体变红
    columnStyle({ row, column, rowIndex, columnIndex }) {
      // console.log( row, column, rowIndex, columnIndex)
      if (row.judgePhone == "false") {
        if (column.label == "联系方式") {
          return "background-color:rgb(255, 67, 98)";
        }
      }
      if (row.contTelJudge == "false") {
        if (column.label == "紧急联络方式") {
          return "background-color:rgb(255, 67, 98)";
        }
      }
      if (row.repeatJudge == "true") {
        if (column.label == "档案号") {
          return "background-color:rgb(255,199,206)";
        }
        if (column.label == "身份证号码") {
          return "background-color:rgb(255,199,206)";
        }
      }
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName });
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.crumbs_left {
  flex: 1;
  display: flex;
  align-items: center;
}
.r_act_right {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.r_act_right .qrcode_img01 {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}
.r_act_right .qrcode_img02 {
  width: 200px;
  height: 200px;
  margin-bottom: 5px;
}
.r_act_right .r_txt02 {
  font-size: 14px;
  color: #409eff;
  margin-left: 8px;
}
.r_act_item .r_txt01 {
  font-size: 14px;
  color: #333;
  margin-right: 5px;
}
.r_act_right .qcode_btn {
  padding: 0;
}
.page-roster .search {
  height: 32px;
  padding: 5px 15px;
  margin-right: 10px;
  border-radius: 5px;
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19bd92;
}
.historyFiled {
  margin-top: 20px;
}
.historyFiled .el-radio-group {
  display: inline-block !important;
  margin-right: 10px;
  margin-top: 10px;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
:focus {
  outline: 0;
}
.top-right {
  display: flex;
  align-items: center;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selectCell {
  margin-top: 20px;
  display: flex;
}
.lineTitle {
  line-height: 48px;
}
</style>

<style>
.customerRosterTable .el-table td {
  padding: 8px 0;
}
.customerRosterTable .el-table th {
  padding: 12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 120px !important;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card > .el-tabs__content {
  max-height: 200px;
  overflow-y: scroll;
}
.dialog .el-card__body {
  max-height: 208px;
  overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
  margin-left: 10px;
}
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19bd92;
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #19bd92;
}
.tagArea .el-checkbox__inner:hover {
  border-color: #19bd92;
}
.tagArea .el-tag--plain.el-tag--success {
  color: #19bd92;
}
.tagArea
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92;
}
.tagArea .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #19bd92;
}
.tableEditInput .el-input__inner {
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0;
  font-size: 13px;
}
.tableEditInput .el-input__icon {
  line-height: 25px;
}
.el-select-dropdown__item.selected {
  color: #19bd92 !important;
}
.historyFiled .el-radio-group {
  display: flex;
}
.updateContract .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px !important;
}
.dataSele .el-input__icon,
.dataSele .el-input__inner {
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
}
/* .historyFiled .el-radio--small.is-bordered{
  margin-bottom: 10px;
} */
</style>
